import React from 'react';
import PropTypes from 'prop-types';

import * as CssClassNames from 'src/constants/CssClassNames';

const FormGroup = ({ label, htmlFor, children }) => (
  <div className={CssClassNames.FORM_GROUP}>
    <label htmlFor={htmlFor}>{label}</label>
    <div className={CssClassNames.FORM_CONTROL_WRAPPERS} id={htmlFor}>
      {children}
    </div>
  </div>
);

FormGroup.propTypes = {
  label: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};

export default FormGroup;
